import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { NotifyService } from 'helpers';
import { GET_PAYMENT_PARAMS_REQUEST, PAYMENT_BODY_RESULT } from 'models';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getPaymentListApi } from 'services';
import { setGlobalLoading } from 'store/reducers/global';
import { setSearchFeeListSuccess } from 'store/reducers/searchfee';
import { GET_SEARCH_FEE_REQUEST } from 'store/reducers/searchfee/actionTypes';

function* getSearchFeeListRequest(
  action: PayloadAction<{
    params?: GET_PAYMENT_PARAMS_REQUEST;
  }>
) {
  try {
    yield put(setGlobalLoading(true));
    const response: AxiosResponse<{
      data: PAYMENT_BODY_RESULT;
    }> = yield call(getPaymentListApi, action.payload.params);
    yield put(
      setSearchFeeListSuccess({
        records: response.data.data.records,
        metadata: response.data.data.metadata,
      })
    );
    yield put(setGlobalLoading(false));
  } catch (error: any) {
    NotifyService.error(error);
    yield put(setGlobalLoading(false));
  }
}

function* searchFee() {
  yield takeLatest(GET_SEARCH_FEE_REQUEST, getSearchFeeListRequest);
}

export default searchFee;
